import { render, staticRenderFns } from "./puryeardeliveryrate.vue?vue&type=template&id=3b060038&scoped=true&"
import script from "./puryeardeliveryrate.vue?vue&type=script&lang=js&"
export * from "./puryeardeliveryrate.vue?vue&type=script&lang=js&"
import style0 from "./puryeardeliveryrate.vue?vue&type=style&index=0&id=3b060038&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b060038",
  null
  
)

export default component.exports